exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".badge-17-wrapper[data-v-4743974a]{width:215px;padding-bottom:10px}.listing-img[data-v-4743974a]{width:20px;height:20px}.background-bottom[data-v-4743974a]{padding:10px;font-size:11px;margin-top:5px;text-align:center}", ""]);

// exports
